import React from 'react';

import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import TablePageLayout from '../../../layouts/TablePageLayout';
import Table from '../../../components/Table';

import BrokerTeamService from '../../../services/BrokerTeamService';
import { useUiStore } from '../../../store';

const cols = [
  {
    title: 'Team name',
    key: 'name',
  },
  {
    title: 'Users',
    key: 'userCount',
  },
];

export default function TeamsPage() {
  const navigate = useNavigate();

  const showDialogModal = useUiStore((state) => state.showDialogModal);

  const { data: brokerTeams, refetch } = useQuery({
    queryKey: ['brokerTeams'],
    queryFn: BrokerTeamService.getBrokerTeams,
  });

  const { mutate: deleteBrokerTeam } = useMutation({
    mutationFn: (id) => BrokerTeamService.deleteBrokerTeam(id),
    onSuccess: () => {
      refetch();
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="bg-gray-50">
      <TablePageLayout title="Teams">
        <Table
          createButtonLabel="Add team"
          onCreateButtonClick={() => navigate('/settings/teams/create')}
          countName="Teams"
          cols={cols}
          rows={brokerTeams}
          actions={[
            {
              title: 'Edit',
              onClick: (row) => navigate(`/settings/teams/${row.id}`),
              icon: 'edit',
            },
            {
              title: 'Delete',
              onClick: (row) =>
                showDialogModal({
                  title: 'Delete team',
                  text: `Are you sure you want to delete team "${row.name}"?`,
                  onConfirm: () => deleteBrokerTeam(row.id),
                }),
              icon: 'delete',
              danger: true,
            },
          ]}
        />
      </TablePageLayout>
    </div>
  );
}
